import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairSyncGuideContent } from "../../PairSyncGuideContent";

export default function SyncAppleMusicToYoutubeMusic() {
    return (
        <GuidesPage
            seoData={seoContent.syncAppleMusicToYoutubeMusic}
            sections={<PairSyncGuideContent sourceKey="appleMusic" destKey="youtubeMusic" />}
        />
    );
}
